// extracted by mini-css-extract-plugin
export default {"infogrid":"dashboard_infogrid__YQ0nc","profile":"dashboard_profile__DSPvm","frmdata":"dashboard_frmdata__WCZRy","table":"dashboard_table__IW7qt"};